import { render, staticRenderFns } from "./ReturnRuleSettings.vue?vue&type=template&id=4eda9fd4&scoped=true"
import script from "./ReturnRuleSettings.vue?vue&type=script&lang=js"
export * from "./ReturnRuleSettings.vue?vue&type=script&lang=js"
import style0 from "./ReturnRuleSettings.vue?vue&type=style&index=0&id=4eda9fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eda9fd4",
  null
  
)

export default component.exports